import { motion } from "framer-motion";
import CAMPAIGN from "@/data/campaign";

const EASE = [0.76, 0, 0.24, 1];

const Itinerary = () => {
  const it = CAMPAIGN.itinerary;

  return (
    <section id="journey" className="py-24 md:py-40 bg-[#EFEADF]" data-testid="itinerary-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-8 md:gap-16 mb-16 md:mb-24 items-end">
          <div className="md:col-span-7">
            <motion.p
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: EASE }}
              className="uppercase text-xs tracking-[0.25em] font-semibold text-primary mb-6"
              data-testid="itinerary-overline"
            >
              {it.overline}
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
              className="font-heading font-light tracking-tight text-foreground text-4xl sm:text-5xl lg:text-6xl leading-[1.02]"
              data-testid="itinerary-heading"
            >
              {it.headingPlain}<br /><em className="text-primary">{it.headingAccent}</em>
            </motion.h2>
          </div>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: EASE, delay: 0.2 }}
            className="md:col-span-5 text-base md:text-lg font-light text-foreground/75 leading-relaxed"
            data-testid="itinerary-intro"
          >
            {it.intro}
          </motion.p>
        </div>

        <div>
          {it.days.map((day, i) => (
            <motion.article
              key={day.n}
              initial={{ opacity: 0, y: 48 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.85, ease: EASE, delay: 0.05 }}
              className="group grid md:grid-cols-12 gap-4 md:gap-10 py-10 md:py-14 border-t border-border items-start hover:bg-secondary/40 transition-colors duration-500 md:px-6"
              data-testid={`itinerary-day-${i + 1}`}
            >
              <div className="md:col-span-3 flex md:block items-baseline gap-4">
                <span className="font-heading font-light text-6xl md:text-8xl text-primary/85 leading-none transition-transform duration-500 md:group-hover:-translate-y-1 inline-block">
                  {day.n}
                </span>
                <span className="md:block md:mt-4 uppercase text-[10px] tracking-[0.25em] font-semibold text-muted-foreground">
                  {day.kicker}
                </span>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-heading text-2xl md:text-4xl font-medium text-foreground leading-tight">
                  {day.title}
                </h3>
                <div className="mt-4 flex flex-wrap gap-2">
                  {day.tags.map((tag) => (
                    <span
                      key={tag}
                      className="text-[10px] uppercase tracking-[0.15em] font-semibold text-primary border border-primary/30 px-3 py-1"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <p className="md:col-span-5 text-sm md:text-base font-light text-foreground/75 leading-relaxed">
                {day.text}
              </p>
            </motion.article>
          ))}
          <div className="border-t border-border" />
        </div>
      </div>
    </section>
  );
};

export default Itinerary;
